import MicroModal from 'micromodal';
import EasingFunctions from './easings.js';

function initCode() {
	self.EasingFunctions = EasingFunctions;
	$ = jQuery.noConflict();

	for (const key in PixelsmithBlocks) {
		if (PixelsmithBlocks.hasOwnProperty(key)) {
			const block = PixelsmithBlocks[key];
			block.init();
		}
	}

	for (const key in PixelsmithModules) {
		if (PixelsmithModules.hasOwnProperty(key)) {
			const block = PixelsmithModules[key];
			block.init();
		}
	}

	if (undefined !== window.PXCustomBlocks && window.acf) {
		window.PXCustomBlocks.forEach((b) => {
			let camelCasedName =
				'PX' +
				b.name
					.split('-')
					.map((el) => el.charAt(0).toUpperCase() + el.slice(1))
					.join('');

			window.acf.addAction(`render_block_preview/type=${b.name}`, PixelsmithBlocks[camelCasedName].init);
		});
	}

	let debounceTimer;
	const emitResize = () => {
		window.dispatchEvent(new Event('px-debounced-resize'));
	};
	const debounceResize = () => {
		clearTimeout(debounceTimer);
		debounceTimer = setTimeout(emitResize, 50);
	};
	window.addEventListener('resize', debounceResize, { capture: true, passive: true });
	const observer = new ResizeObserver(debounceResize);
	observer.observe(document.body);
	debounceResize();
}

if (document.readyState !== 'loading') {
	console.log('document is already ready, just execute code here');
	initCode();
} else {
	document.addEventListener('DOMContentLoaded', function () {
		console.log('document was not ready, listening to DOMContentLoaded');
		initCode();
	});
}
